import React, { FC, createContext } from 'react';
import { useSearch } from './search-hook';

type DashboardSearchContextType = ReturnType<typeof useSearch>;
export const DashboardSearchContext = createContext<DashboardSearchContextType>(
  {} as unknown as DashboardSearchContextType
);

export const DashboardSearchContextProvider: FC = ({ children }) => {
  return (
    <DashboardSearchContext.Provider value={useSearch()}>
      {children}
    </DashboardSearchContext.Provider>
  );
};
